import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
    selector: 'lib-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChipComponent {
	public readonly title = input<string>();
	public readonly isActive = input<boolean>(false);

	@HostBinding('style') style = 'display: inline-block';
}
